export const REDACTED_REFRESH_TOKEN = 'redacted-refresh-token';
